// Test IDs for the authenticated Explore feature. Naming follows the
// directive in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const EXPLORE = {
	page: 'explore-page',
	navLink: 'app-nav-explore',
	search: 'explore-search',
	searchInput: 'explore-search-input',
};
